import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import AddFund from '../components/AddFund';
import visa from '../assets/images/visa.png';
import mastercard from '../assets/images/master_card.png';
import m_card from '../assets/images/m_card.png';
import club from '../assets/images/d_club.png';
import discover from '../assets/images/discover.png';
import check_mark from '../assets/images/Check.svg';
import jcb from '../assets/images/jcb.png';
import nopayment from '../assets/images/No payment.svg';
import loaderIcon from '../assets/images/loader.gif';
import config from '../config/config';

const PaymentOptions = () => {
  const navigate = useNavigate();
  const [walletData, setWalletData] = useState(null);
  const [paystackTransactions, setPaystackTransactions] = useState([]);
  const [nowpaymentsTransactions, setNowpaymentsTransactions] = useState([]);
  const [allTransactions, setallTransactions] = useState([]);
  const [walletTransactions, setWalletTransactions] = useState([]);
  const [withdrawRequests, setWithdrawRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [visibleTransactions, setVisibleTransactions] = useState(5);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const modalRef = useRef(null);
  const [userDetails, setUserDetails] = useState({});  
  const [loadingFeedWrapper, setLoadingFeedWrapper] = useState(false);

  const token = localStorage.getItem('token');
  const [refreshingTransactions, setRefreshingTransactions] = useState(false);

  useEffect(() => {
  const fetchData = async () => {
    try {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }      
      // Fetch wallet info
      const walletResponse = await axios.get(`${config.baseURL}/get-wallet-info`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const walletData = walletResponse.data;
      if (walletData.success) {
        setWalletData(walletData.wallet_data);
        setWalletTransactions(walletData.wallet_transactions);
        setWithdrawRequests(walletData.withdraw_requests);
      } else {
        console.error('Failed to fetch wallet data');
      }

      // Fetch user details
      const userDetailsResponse = await axios.get(`${config.baseURL}/current-user-details`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (userDetailsResponse.data.success) {
        setUserDetails({
          user: userDetailsResponse.data.data.user,
          user_details: userDetailsResponse.data.data.user_details,
        });
      } else {
        console.error('Failed to fetch user details');
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading to false once data is fetched
    }
  };

  fetchData(); // Call the async function inside useEffect
}, []);


  useEffect(() => {
    const fetchPaystackInfo = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-paystack-info`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = response.data;

        if (data.success) {
          setPaystackTransactions(data.paystack_transactions);
        } else {
          console.error('Failed to fetch Paystack transactions');
        }
      } catch (error) {
        console.error('Error fetching data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaystackInfo();
  }, []);


  useEffect(() => {
    const fetchnowpaymentsInfo = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-nowpayments-info`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = response.data;

        if (data.success) {
          setNowpaymentsTransactions(data.nowpayment_transactions);
        } else {
          console.error('Failed to fetch Paystack transactions');
        }
      } catch (error) {
        console.error('Error fetching data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchnowpaymentsInfo();
  }, []);


  const fetchallpaymentsInfo = async () => {
    setRefreshingTransactions(true); // Start the loader for LATEST TRANSACTIONS
    setLoadingFeedWrapper(true); // Start the loader for feed_wrapper
    try {
      const response = await axios.get(`${config.baseURL}/get-latest-transaction`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response.data;
  
      if (data.success) {
        setallTransactions(data.latest_transactions); // Update transactions
        showToast('Transactions refreshed successfully.', 'success');
      } else {
        console.error('Failed to fetch transactions');
        showToast('Failed to refresh transactions.');
      }
    } catch (error) {
      console.error('Error fetching data', error);
      showToast('Error occurred while refreshing transactions.');
    } finally {
      setRefreshingTransactions(false); // Stop the loader for LATEST TRANSACTIONS
      setLoadingFeedWrapper(false); // Stop the loader for feed_wrapper
    }
  };
  
  

  useEffect(() => {
    fetchallpaymentsInfo();
  }, []);

  const formatDate = (dateString) => {
    const optionsDate = { year: 'numeric', month: 'short', day: 'numeric' };
    const optionsTime = { hour: 'numeric', minute: 'numeric', hour12: true };

    const datePart = new Date(dateString).toLocaleDateString('en-US', optionsDate);
    const timePart = new Date(dateString).toLocaleTimeString('en-US', optionsTime);

    return `${datePart} | ${timePart}`;
  };

  const showMoreTransactions = () => {
    setVisibleTransactions(allTransactions.length);
  };

const handleWithdraw = async () => {
  setLoading(true);
  try {
    const response = await axios.post(
      `${config.baseURL}/make-withdraw-request`,
      { amount: withdrawAmount },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const { success, message } = response.data;

    if (success) {
      showToast(message || 'Withdraw request successful!', 'success');
      
      // Hide the modal manually
      handleCloseModal(); // Call the function to close the modal

      // Remove the backdrop manually after a short delay
      setTimeout(() => {
        document.querySelectorAll('.modal-overlay').forEach(el => el.classList.remove('show'));
      }, 300); // Delay to ensure the modal has fully closed
    } else {
      showToast(message || 'Withdraw request failed.');
    }
  } catch (error) {
    console.error('Error making withdraw request', error);
    showToast('Error making withdraw request.');
  } finally {
    setLoading(false);
    setWithdrawAmount(''); // Reset the input field
  }
};

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const showToast = (message, type = 'error') => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 5000); // Adjust duration as needed
  };

  const handleOpenModal = () => {
  setShowWithdrawModal(true);
  };

  const handleCloseModal = () => {
    setShowWithdrawModal(false);
  };

  useEffect(() => {
    document.title = "Payment Options - PatreonPass";
  }, []);

  return (
    <div>
      <div className="main_patreonpass_wrapper"> 
        <div className="patreonpass_container">
          
          <div className="left_sidebar">
            <MainSidebar />
          </div>

          <div className="patreonpass_main_content" id="content">  
                <div className="left_main_content">
                  <div className="feed_wrapper">
      
                    <div className="page_title_with_dropdown create_post_page payment_cards"> 
                      <div className="page_heading">
                        <button className="profile_back_btn create_post_btn">
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                              stroke="#222"
                              strokeWidth={6}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <h1>Payment Options</h1>
                      </div>
                    </div>
                    <div className="add_card_block">
                    {loadingFeedWrapper ? (
    <div className="text-center gf-qs">
      <img className="loading_icon" src={loaderIcon} alt="Loading Feed..." />
    </div>
  ) : (
    <>
                      <div className="post_media_block payment_cards_block payment_options_tabs">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link active"
                              id="posts-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#posts"
                              type="button"
                              role="tab"
                              aria-controls="posts"
                              aria-selected="true"
                            >
                              {" "}
                              PayStack{" "}
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="media-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#media"
                              type="button"
                              role="tab"
                              aria-controls="media"
                              aria-selected="false"
                              tabIndex={-1}
                            >
                              {" "}
                              Cryptocurrency{" "}
                            </button>
                          </li>
                          {userDetails?.user?.role === 'creator' && (
  <li className="nav-item" role="presentation">
    <button
      className="nav-link"
      id="fund_wallet-tab"
      data-bs-toggle="tab"
      data-bs-target="#fund_wallet"
      type="button"
      role="tab"
      aria-controls="media"
      aria-selected="false"
      tabIndex={-1}
    >
      {" "}
      Fund Wallet{" "}
    </button>
  </li>
)}

                        </ul>
                        {/* Tab Content */}
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="posts"
                            role="tabpanel"
                            aria-labelledby="posts-tab"
                          >
                            <table
                            cellPadding={0}
                            cellSpacing={0}
                            border={0}
                            className="b-table big_table_view m-responsive m-default-table m-compact-view-mode m-reset-bt"
                          >
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th colSpan={2} className="text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paystackTransactions.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="text-center width_full_table">
                                      <div className="no_payment_with_Text">
                                        <img src={nopayment} alt="No Payments" />
                                        No Payments done yet.
                                      </div>
                                  </td>
                                </tr>
                              ) : (
                                paystackTransactions.map((transaction, index) => (
                                  <tr className="m-responsive__reset-pb" key={index}>
                                    <td className="m-responsive__before-line-over m-responsive__equal-width_float">
                                      <span title="" className="datetime payments-card__date">
                                        <span className="date">
                                          {formatDate(transaction.created_at)}
                                        </span>
                                      </span>
                                    </td>
                                    <td className="m-responsive__before-line-over m-last-in-row">
                                      <strong>${transaction.amount}</strong>
                                    </td>
                                    <td className="m-responsive__border-line__over text-left">
                                      <div className="b-transaction-state">
                                        <div className="b-card-box__description m-break-word">
                                          <span>
                                            Payment for <strong>{transaction.payment_for}</strong> to{" "}
                                            <a href={`${transaction.to_user.user_name}`}>{transaction.to_user.name}</a>
                                          </span>
                                        </div>
                                      </div>
                                      <div className="b-table-group-btns m-done-position">
                                        <div className="b-table__status-tip m-relative">
                                          <img
                                            className="check_icon_table"
                                            src={check_mark}
                                            alt="Completed"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                            <div className="b-credit-cards">
                              <div className="img_cards">
                                <img src={visa} alt="Visa" />
                              </div>
                              <div className="img_cards">
                                <img src={mastercard} alt="Mastercard" />
                              </div>
                              <div className="img_cards">
                                <img src={m_card} alt="M Card" />
                              </div>
                              <div className="img_cards">
                                <img src={club} alt="Club" />
                              </div>
                              <div className="img_cards">
                                <img src={discover} alt="Discover" />
                              </div>
                              <div className="img_cards">
                                <img src={jcb} alt="JCB" />
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="media"
                            role="tabpanel"
                            aria-labelledby="media-tab"
                          >
                          <table
                            cellPadding={0}
                            cellSpacing={0}
                            border={0}
                            className="b-table big_table_view m-responsive m-default-table m-compact-view-mode m-reset-bt"
                          >
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th colSpan={2} className="text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {nowpaymentsTransactions.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="text-center width_full_table">
                                      <div className="no_payment_with_Text">
                                        <img src={nopayment} alt="No Payments" />
                                        No Payments done yet.
                                      </div>
                                  </td>
                                </tr>
                              ) : (
                                nowpaymentsTransactions.map((transaction, index) => (
                                  <tr className="m-responsive__reset-pb" key={index}>
                                    <td className="m-responsive__before-line-over m-responsive__equal-width_float">
                                      <span title="" className="datetime payments-card__date">
                                        <span className="date">
                                          {formatDate(transaction.created_at)}
                                        </span>
                                      </span>
                                    </td>
                                    <td className="m-responsive__before-line-over m-last-in-row">
                                      <strong>${transaction.amount}</strong>
                                    </td>
                                    <td className="m-responsive__border-line__over text-left">
                                      <div className="b-transaction-state">
                                        <div className="b-card-box__description m-break-word">
                                          <span>
                                            Payment for <strong>{transaction.payment_for}</strong> to{" "}
                                            <a href={`${transaction.to_user.user_name}`}>{transaction.to_user.name}</a>
                                          </span>
                                        </div>
                                      </div>
                                      <div className="b-table-group-btns m-done-position">
                                        <div className="b-table__status-tip m-relative">
                                          <img
                                            className="check_icon_table"
                                            src={check_mark}
                                            alt="Completed"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                           </table>
                          </div>
                          {userDetails?.user?.role !== 'user' && (
                          <div
                            className="tab-pane fade"
                            id="fund_wallet"
                            role="tabpanel"
                            aria-labelledby="fund_wallet-tab"
                          >
                            <ul className="nav nav-tabs sub_tabs_list" id="myTab" role="tablist">
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link active"
                                  id="wallet-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#wallet_transition"
                                  type="button"
                                  role="tab"
                                  aria-controls="wallet_transition"
                                  aria-selected="true"
                                >
                                  Wallet Transactions
                                </button>
                              </li>

                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link"
                                  id="withdraw-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#withdraw_requests"
                                  type="button"
                                  role="tab"
                                  aria-controls="withdraw_requests"
                                  aria-selected="false"
                                >
                                  Withdrawal Requests
                                </button>
                              </li>
                            </ul>

                            <div className="tab-content" id="myTabContent">
                                <div
                                  className="tab-pane fade show active"
                                  id="wallet_transition"
                                  role="tabpanel"
                                  aria-labelledby="wallet-tab"
                                >
                                  {walletTransactions.length === 0 ? (
                                    <div className="no_payment_with_Text">
                                      <img src={nopayment} alt="No Transactions" />
                                      No Transactions done yet.
                                    </div>
                                  ) : (
                                    <table className="table details_table">
                                      <thead>
                                        <tr>
                                          <th>ID</th>
                                          <th>For</th>
                                          <th>Amount($)</th>
                                          <th>Commission($)</th>
                                          <th>Comment</th>
                                          <th>Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {walletTransactions.map(transaction => (
                                          <tr key={transaction.wallet_trans_id}>
                                            <td>{transaction.wallet_trans_id}</td>
                                            <td>{transaction.transaction_for}</td>
                                            <td>${transaction.amount}</td>
                                            <td>${transaction.admin_commission}</td>
                                            <td>
                        {transaction.tip_comment ? (
                          <span className="tip-comment text-muted">
                            {transaction.tip_comment}
                          </span>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                                            <td>{formatDate(transaction.created_at)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  )}
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="withdraw_requests"
                                  role="tabpanel"
                                  aria-labelledby="withdraw-tab"
                                >
                                  {withdrawRequests.length === 0 ? (
                                    <div className="no_payment_with_Text">
                                      <img src={nopayment} alt="No Withdrawals" />
                                      No Withdrawals done yet.
                                    </div>
                                  ) : (
                                    <table className="table details_table">
                                      <thead>
                                        <tr>
                                          <th>Request ID</th>
                                          <th>Amount</th>
                                          <th>Status</th>
                                          <th>Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {withdrawRequests.map(request => (
                                          <tr key={request.request_id}>
                                            <td>{request.withdraw_trans_id}</td>
                                            <td>${request.amount}</td>
                                            <td>{request.status}</td>
                                            <td>{formatDate(request.created_at)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </div>                            
                          </div>
                          )}

                        </div>
                      </div>
                     </>
                      )}
                    </div>
                
                  </div>
                </div>
                <div className="right_main_content">                  
                  
                {!loading ? (
  <>
    {  userDetails?.user?.role !== 'user' && (
                      <div
                        className="tab-pane faded_w"
                        id="fund_wallet"
                        role="tabpanel"
                        aria-labelledby="fund_wallet-tab"
                      >
                        {/* Content of the fund_wallet tab */}
                        <div className="wallet_credit">
                          <div className="wallet_credit_header">
                            {/* Display wallet balance if available, otherwise show '0' */}
                            <span className="balance-info">
                              ${walletData?.current_balance || '0'}
                            </span>
                            Wallet Credits
                          </div>
                          <div className="wallet_credit_content">
                            <h4 className="wallet_content_heading">Withdraw your wallet funds</h4>
                            {/* Button to trigger withdrawal modal */}
                            <Link onClick={handleOpenModal} className="subscription_btn center-text">
                              <span>Withdraw Now</span>
                            </Link>
                            {userDetails && userDetails.user ?(
                            <AddFund 
                              UserId={userDetails.user.id} 
                              UserName={userDetails.user.user_name} 
                            />
                             ) : (
                              <p></p> 
                            )}
                          </div>
                        </div>
                      </div>
                    )}

    { userDetails?.user?.role !== 'creator' && (
                    <div className="wallet_credit add_mony_box">
                    <div className="wallet_credit_header">
                        {/* Display wallet balance if available, otherwise show '0' */}
                          <span className="balance-info">
                            ${walletData?.current_balance || '0'}
                          </span>
                          Wallet Credits
                    </div>
                    <div className="wallet_credit_content">
                      <h4 className="wallet_content_heading">ADD FUNDS TO YOUR WALLET</h4>                      
                      {/* Button to trigger withdrawal modal */}
                      {userDetails && userDetails.user ?(
                        <AddFund 
                          UserId={userDetails.user.id} 
                          UserName={userDetails.user.user_name} 
                        />
                         ) : (
                          <p></p> 
                        )}
                    </div>
                  </div>
                    )}
  </>
) : (
  <div className="text-center"> 
    <img className="loading_icon" src={loaderIcon} alt="Loading..." /> 
  </div>
)}


<div className="wallet_credit latest_transition">
  <div className="wallet_credit_header">
    <h4 className="wallet_content_heading">
      LATEST TRANSACTIONS
      <span>
        <svg onClick={fetchallpaymentsInfo} className="apirefersh"
          width={38}
          height={38}
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99839 14.5049C6.99839 14.5049 7.68944 11.6237 8.94367 9.96589C13.0191 4.57901 22.1332 4.98889 26.4903 9.33357C27.2701 10.1134 27.889 10.9675 28.3965 11.8834"
            stroke="#8A96A3"
            strokeWidth="3.24214"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.0755 13.8569H30.5273V7.40512"
            stroke="#8A96A3"
            strokeWidth="3.24214"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.7145 24.1562C30.7145 24.1562 30.0235 27.0374 28.7692 28.6952C24.6938 34.0821 15.5797 33.6722 11.2226 29.3276C10.4428 28.5477 9.8239 27.6937 9.31641 26.7777"
            stroke="#8A96A3"
            strokeWidth="3.24214"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.6374 24.8042H7.18555V31.256"
            stroke="#8A96A3"
            strokeWidth="3.24214"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </h4>
  </div>
  <div className="wallet_credit_content">
    {refreshingTransactions ? (
      <div className="text-center">
        <img className="loading_icon" src={loaderIcon} alt="Refreshing..." />
      </div>
    ) : (
      <table
        cellPadding={0}
        cellSpacing={0}
        border={0}
        className="b-table big_table_view m-responsive m-default-table m-compact-view-mode m-reset-bt"
      >
        <thead>
          <tr>
            <th>Date</th>
            <th colSpan={2} className="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {allTransactions.length === 0 ? (
            <tr>
              <td colSpan={3} className="text-center width_full_table">
                <div className="no_payment_with_Text">
                  <img src={nopayment} alt="No Payments" />
                  No Payments done yet.
                </div>
              </td>
            </tr>
          ) : (
            allTransactions.slice(0, visibleTransactions).map((transaction, index) => (
              <tr className="m-responsive__reset-pb" key={index}>
                <td className="m-responsive__before-line-over m-responsive__equal-width_float">
                  <span title="" className="datetime payments-card__date">
                    <span className="date">
                      {formatDate(transaction.created_at)}
                    </span>
                  </span>
                </td>
                <td className="m-responsive__before-line-over m-last-in-row">
                  <strong>${transaction.amount}</strong>
                </td>
                <td className="m-responsive__border-line__over text-left">
                  <div className="b-transaction-state">
                    <div className="b-card-box__description m-break-word">
                      <span>
                        Payment for <strong>{transaction.payment_for}</strong> to{" "}
                        <a href={`/user/${transaction.to_user.user_name}`}>{transaction.to_user.name}</a>
                      </span>
                    </div>
                  </div>
                  <div className="b-table-group-btns m-done-position">
                    <div className="b-table__status-tip m-relative">
                      <img
                        className="check_icon_table"
                        src={check_mark}
                        alt="Completed"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    )}
    {visibleTransactions < allTransactions.length && (
      <div className="b-useful-data__row-btn text-center">
        <Link onClick={showMoreTransactions} className="g-btn m-rounded m-border m-block">
          View more transactions
        </Link>
      </div>
    )}
  </div>
</div>

                </div>
              </div>     

            {/* Bootstrap Modal */}              

            <div className={`modal-overlay ${showWithdrawModal ? 'show' : ''}`} onClick={handleCloseModal} /> 

              <div className={`modal withdrawModal fade ${showWithdrawModal ? 'show' : ''}`} tabIndex="-1" aria-labelledby="withdrawModalLabel" aria-hidden="true" style={{ display: showWithdrawModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="withdrawModalLabel">Withdraw Funds</h5>
                      <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleWithdraw();
                        }}
                      >
                        <div className="mb-3">
                          <input
                            placeholder="Enter Amount"
                            type="number"
                            className="form-control"
                            id="withdrawAmount"
                            value={withdrawAmount}
                            onChange={(e) => setWithdrawAmount(e.target.value)}
                            required
                          />
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary send_btn" onClick={handleCloseModal}>
                            Close
                          </button>
                          <button type="submit" className="btn btn-primary send_btn" disabled={loading}>
                            {loading ? 'Processing...' : 'Withdraw'}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>


      {toastMessage && (
        <div className={`toastmessage ${toastType} ${toastMessage ? 'show' : ''}`}>
          {toastMessage}
        </div>
      )}


        </div>
      </div>
    </div>

  );
};

export default PaymentOptions;
